import React, { useEffect, useState } from 'react'
import ReactDOM from 'react-dom'
import styles from './style.css'

const View = ({ Grounds }) => {
    const [down, setDown] = useState(false)
    const [statInfo, setStatInfo] = useState([])

    useEffect(() => {
        Grounds.on('stat', (data) => {
            setStatInfo((pre) => [...pre, data])
        })
    }, [])

    return (
        <div className={`${styles.layout} ${down ? styles.down : null}`}>
            <div className={styles.start}>------------- START -------------</div>
            <div className={styles.info} onClick={() => setDown(!down)} onScroll={(e) => e.stopPropagation()}>
                {
                    statInfo.map((item, index) => {
                        const info = Object.assign({}, item)
                        const time = info._time
                        const type = info._type

                        delete info._time
                        delete info._type

                        return <div key={index} className={styles.item}>
                            <div>{time.toTimeString()}</div>
                            <div>Type: {type}</div>
                            <div>{Object.keys(info).map(item => `${item}=${info[item]} `)}</div>
                            <div>----------------------</div>
                        </div>
                    })
                }
            </div>
            <div className={styles.end}>------------- END -------------</div>
        </div>
        
    )
}

export const renderDebugView = (Grounds) => {
    if (typeof window !== 'object' || typeof location !== 'object' || !location.search.match('statDebug')) return null
    
    const root = document.createElement('div')

    root.setAttribute('id', 'statDebug')
    document.querySelector('body').appendChild(root)

    ReactDOM.render(<View Grounds={Grounds}/>, document.getElementById('statDebug'))
}